Librarian.HTMLWindow = new Class({
    Extends: Librarian.Window,
    Binds: [
        "setHeight", "onResize"
    ],

    options: {
        id: "HTMLWindow",
        title: '',
        message: null,
        minimizable: false,
        height: 400,
        width: 650,
        placeholders: null
    },

    initialize: function(options) {
        this.setOptions(options);

        var self = this,
            placeholders = this.options.placeholders;

        if (placeholders) {
            for (var i = 0; i < placeholders.length; i++) {
                Object.keys(placeholders[i])
                .forEach(function eachKey(key) { 
                    self.options.html = self.options.html.replaceAll(key, placeholders[0][key]);
                });
            }
        }

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.setupElements();

        if (this.options.html) 
            this.contentEl.set("html", this.options.html);

        this.setHeight();
    },

    setHeight: function() {
        this.options.height = this.contentEl.getHeight();
        this.resize();
    }
});